'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { Record } from 'immutable';
import { AdCreationTypes } from 'AdsUI/lib/Constants';
export const DraftType = {
  SEQUENCE: 'SEQUENCE',
  AD: 'AD'
};
export const DraftSortColumns = {
  NAME: 'name',
  TYPE: 'type',
  AD_ACCOUNT: 'adAccount',
  UPDATED_AT: 'updatedAt'
};

class DraftRecord extends Record({
  id: null,
  name: null,
  adAccountId: null,
  adNetwork: null,
  createdAt: null,
  deletedAt: null,
  hubSpotUserId: null,
  portalId: null,
  updatedAt: null,
  updatedByHubSpotUserId: null,
  updatedByHubSpotUserName: null,
  type: null,
  draft: null
}) {
  constructor(networkDraft) {
    const {
      draft
    } = networkDraft,
          draftInfo = _objectWithoutPropertiesLoose(networkDraft, ["draft"]);

    const parsedDraft = JSON.parse(draft);
    super(Object.assign({}, draftInfo, {
      draft: parsedDraft
    }));
  }

  get displayType() {
    switch (this.type) {
      case DraftType.AD:
        return this.draft.adType || AdCreationTypes.LEAD_AD;

      default:
        return this.type.toLowerCase();
    }
  }

}

export default DraftRecord;